import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_TRACKER = "/api/course_enrollments";

export default {
  async getCoursesEnrollment(params) {
    return await Api()
      .get(RESOURCE_TRACKER, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async createCourseEnrollment(params) {
    return Api()
      .post(RESOURCE_TRACKER, params)
      .catch((err) => errorHandler(err, null));
  },
  async updateCourseEnrollment(id, params) {
    return Api()
      .put(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async getCourseEnrollment(id, params) {
    return Api()
      .get(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async discardCourseEnrollment(id) {
    return Api()
      .delete(`${RESOURCE_TRACKER}/${id}`)
      .catch((err) => errorHandler(err, null));
  },
  async confirmCourseEnrollment(id, params) {
    return Api()
      .post(RESOURCE_TRACKER + "/" + id + "/confirm", params)
      .catch((err) => errorHandler(err, null));
  },
  async cancelCourseEnrollment(id, params) {
    return Api()
      .post(RESOURCE_TRACKER + "/" + id + "/cancel", params)
      .catch((err) => errorHandler(err, null));
  },
};
